import styles from './Delivery.module.scss';

import InfoIcon from '@mui/icons-material/Info';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DateTimePickerField } from '@work4all/components';

import { useFormContextPlus } from '../../../../../../../../form-plus/use-form-context-plus';
import { Collapse } from '../../../../../../../components';
import { ReViewModelFormValue } from '../../../../../types';

export function Delivery() {
  const { t } = useTranslation();

  const form = useFormContextPlus<ReViewModelFormValue>();
  const { control } = form;

  return (
    <Collapse
      className={styles.delivery}
      title={t('MASK.DELIVERY')}
      defaultOpen
    >
      <Stack spacing={2}>
        <Grid container direction="row" spacing={2} columns={2}>
          <Grid item xs>
            <Controller
              control={control}
              name="plannedDeliveryDate"
              render={({ field }) => {
                return (
                  <DateTimePickerField
                    {...field}
                    clearable
                    hideTime
                    dateLabel={t('INPUTS.PLANNED_DELIVERY_DATE')}
                  />
                );
              }}
            />
          </Grid>

          <Grid item xs>
            <Controller
              control={control}
              name="deliveryDate"
              render={({ field }) => {
                return (
                  <DateTimePickerField
                    {...field}
                    clearable
                    hideTime
                    dateLabel={t('INPUTS.ACTUAL_DELIVERY_DATE')}
                  />
                );
              }}
            />
          </Grid>
        </Grid>

        <Stack direction="row" alignItems="center" spacing={0.5} px={1}>
          <InfoIcon color="primary" fontSize="medium" />

          <Typography variant="caption">
            {t('MASK.DELIVERY_RELIABILITY_INFO')}
          </Typography>
        </Stack>
      </Stack>
    </Collapse>
  );
}
